import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const TrandingCardPlaceholder = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      {...props}
      width="100%"
      height={78}
      viewBox="0 0 336 78"
      preserveAspectRatio="none"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
    >
      <rect x="246" y="0" rx="8" ry="8" width="90" height="68" />
      <rect x="0" y="0" rx="8" ry="8" width="200" height="18" />
      <rect x="0" y="34" rx="8" ry="8" width="140" height="16" />
      <rect x="0" y="66" rx="8" ry="8" width="100" height="12" />
    </ContentLoader>
  );
};
